<!-- pi-v2-info-applicant.component.html -->
<div class="applicant d-flex flex-column">
    <div class="d-flex mt-3 justify-content-between flex-column flex-md-row">
        <div class="d-flex justify-content-end">
            <img class="applicant-logo" [src]="getLogoUrl(developer?.logo || developer?.logoDevelopment)" alt="developer-logo">
        </div>
        <div class="d-flex align-items-end justify-content-end">
            <div class="d-flex align-items-end justify-content-end">
                <div *ngIf="developer?.social?.facebook" class="ms-3">facebook</div>
                <div *ngIf="developer?.social?.twitterX" class="ms-3">twitterX</div>
                <div *ngIf="developer?.social?.instagram" class="ms-3">instagram</div>
                <div *ngIf="developer?.social?.web" class="ms-3">web</div>
                <div *ngIf="developer?.social?.tiktok" class="ms-3">tiktok</div>
                <div *ngIf="developer?.social?.linkedin" class="ms-3">linkedin</div>
            </div>
        </div>
    </div>
    <div class="mt-3" style="text-align: justify;">
        <p class="fs-14" [innerHTML]="developer?.description"></p>
    </div>
</div>
